import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import apolloProvider from './plugins/vue-apollo';
import { abilitiesPlugin } from '@casl/vue';
import { ability, initializeAbilityFromStorage } from '@/utils/caslAbility';
import Notifications from 'vue-notification'
import CKEditor from '@ckeditor/ckeditor5-vue2'
Vue.config.productionTip = false

Vue.use(abilitiesPlugin, ability);
initializeAbilityFromStorage();

const originalSetItem = localStorage.setItem;

localStorage.setItem = function (key, value) {
  const oldValue = localStorage.getItem(key);
  originalSetItem.apply(this, arguments);

  window.dispatchEvent(
    new CustomEvent("localstorage-change", {
      detail: { key, oldValue, newValue: value }
    })
  );
};

Vue.prototype.$canAny = function (permissions) {
  if (permissions.includes('*')) return true;

  permissions.push('ADMINISTRATOR');
  const staticPermissions = JSON.parse(localStorage.getItem('permissions'));
  // Special case: 'authenticated' means any logged-in user can access
  if (permissions.includes('authenticated') && staticPermissions && staticPermissions.length > 0) {
    return true;
  }
  return staticPermissions.some(item => permissions.includes(item));
};
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
Vue.use(Notifications)
Vue.use(CKEditor)


const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    ar: require('./locales/ar.json'),
    en: require('./locales/en.json')
  }
})
new Vue({
  router,
  store,
  vuetify,
  i18n,
  apolloProvider,
  render: function (h) { return h(App) },
  data: {
    ability
  }
}).$mount('#app')
